// QR Kiosk v2 — shared floating back pill (§7.1-A). Extracted VERBATIM-styled from
// the KPage Pass-2 pill (owner-approved: 48px, radius 999, --card bg, --border,
// 14.5/700, left-arrow SVG, shadow, usePressed, safe-area bottom offset). ONE visual
// on ALL surfaces — reads perfectly on the dark carousel too, so there is deliberately
// NO dark variant. The label is a function of the back TARGET; the caller (KPage or the
// overlay/takeover) decides kioskBack vs kioskBackToMenu.
import React from "react";
import { usePressed } from "./usePressed";

/** Single source of the pill button's visual — spread here AND by carousel composed rows. */
export const pillVisual: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  height: 48,
  padding: "0 26px",
  borderRadius: 999,
  border: "1px solid var(--border)",
  background: "var(--card)",
  color: "var(--ink)",
  fontFamily: "inherit",
  fontSize: 14.5,
  fontWeight: 700,
  whiteSpace: "nowrap",
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  boxShadow: "0 4px 16px rgba(15,23,42,0.16), 0 1px 4px rgba(15,23,42,0.08)",
};

export function BackArrow() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 12 H5" />
      <path d="M12 19 L5 12 L12 5" />
    </svg>
  );
}

export interface BackPillProps {
  label: string; // pre-translated — caller decides kioskBack vs kioskBackToMenu
  onBack: () => void; // navigate OR close-overlay
  zIndex?: number; // default 30 (route level); takeovers 42; carousel 1405
}

export function BackPill({ label, onBack, zIndex = 30 }: BackPillProps) {
  const backPress = usePressed();
  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: "max(16px, calc(env(safe-area-inset-bottom, 0px) + 10px))",
        zIndex,
        display: "flex",
        justifyContent: "center",
        pointerEvents: "none",
      }}
    >
      <button
        type="button"
        {...backPress.pressHandlers}
        onClick={onBack}
        style={{ ...pillVisual, pointerEvents: "auto", ...backPress.pressStyle }}
      >
        <BackArrow />
        {label}
      </button>
    </div>
  );
}

export default BackPill;
